// extracted by mini-css-extract-plugin
module.exports = {"FeatureStatusBadge":"_1B1mjgbh"};